// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"385":"deaf4b4c","653":"4917af3b","972":"795fb6fc"}[chunkId] + ".js";
};